/*
  The Read more toggle for the clamped hero copy on collection pages.

  The clamp itself is CSS and lives in main-collection.css. This file only adds
  the control that opens it.

  Was the variant arm of the `collection-products-first` split test, which
  concluded 2026-10-07 at +5.87% on collection card clicks over 133,867
  visitors and shipped to everyone. The assignment gate is gone with it: the
  button now mounts for every visitor, and start() already no-ops where there
  is nothing to clamp.

  A standalone asset rather than an edit to global.js, which ships minified with
  no build step here, per the theme's own rule for adding behaviour.
*/
(function () {
  'use strict';

  var COPY = '.hero-banner-txt-content__wrapper .heading-block.u-p3';
  var OPEN = 'wb-copy-open';
  var mounted = false;

  /*
    Labels come off the script tag, the way _product-description does it, so the
    strings stay in locales/ and this file stays language-free. They reuse
    products.product.show_more and show_less: the wording is generic and already
    translated everywhere, which beats adding a key to every locale file.
  */
  var script = document.currentScript || document.querySelector('script[src*="wb-collection-products-first"]');

  function label(name, fallback) {
    return (script && script.getAttribute('data-' + name)) || fallback;
  }


  var UNCLIP = 'wb-copy-unclip';

  /*
    Release whatever is clipping the copy while it is open.

    The hero is a Swiper, and on the collections whose hero is not `banner-hero`
    the theme's own `height: auto` rule does not reach it, so the container keeps
    the height Swiper measured at init. Expanding the copy then grows the slide
    inside a box that does not grow with it: measured on royal-pop-straps,
    .media-slideshow__swiper stayed 264px around 424px of content and cut the
    last line off mid-sentence.

    Found by walking up rather than by naming hero classes, because there is
    more than one hero implementation and this has to work on all of them. Only
    ancestors that are actually clipping are touched, and only while open.
  */
  function unclipAncestors(el) {
    var node = el.parentElement;
    var touched = [];
    while (node && node !== document.body) {
      if (node.scrollHeight > node.clientHeight + 1) {
        node.classList.add(UNCLIP);
        touched.push(node);
      }
      node = node.parentElement;
    }
    return touched;
  }

  function reclipAncestors(nodes) {
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.remove(UNCLIP);
  }

  function collectionHandle() {
    var m = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return m ? m[1] : 'unknown';
  }

  function publish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) {
      /* analytics must never break the page */
    }
  }

  /*
    The variant's CSS arrives inside a <template> the embed expands, so it can
    land after this runs. This is the gate: the clamp is live only once the
    computed line-clamp is the variant's.
  */
  function clampLive(el) {
    var cs = getComputedStyle(el);
    return (cs.webkitLineClamp || cs.getPropertyValue('-webkit-line-clamp')) === '2';
  }

  /*
    Only worth a button when the copy is actually cut off. A short collection
    description that fits in two lines would get a Show more that reveals
    nothing.

    Measured by opening it rather than by scrollHeight: on a -webkit-box the
    element is sized to the clamp, so scrollHeight and clientHeight match and
    the usual overflow test reports no overflow on copy that is plainly cut.
  */
  function isClamped(el) {
    var closed = el.getBoundingClientRect().height;
    el.classList.add(OPEN);
    var open = el.getBoundingClientRect().height;
    el.classList.remove(OPEN);
    return open - closed > 4;
  }

  function mount() {
    if (mounted) return;
    var copy = document.querySelector(COPY);
    if (!copy || copy.parentNode.querySelector('.wb-copy-more')) return;
    if (!clampLive(copy)) return;
    if (!isClamped(copy)) { mounted = true; return; }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wb-copy-more u-p3';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = label('show-more', 'Show more');

    var unclipped = [];
    btn.addEventListener('click', function () {
      var open = copy.classList.toggle(OPEN);
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? label('show-less', 'Show less') : label('show-more', 'Show more');
      if (open) {
        /* After the class, so the copy is at its full height when ancestors are measured. */
        unclipped = unclipAncestors(copy);
        publish('collection_description_expanded', { collection: collectionHandle() });
      } else {
        reclipAncestors(unclipped);
        unclipped = [];
      }
    });

    copy.insertAdjacentElement('afterend', btn);
    mounted = true;
  }

  function start() {
    if (!document.body || !document.body.classList.contains('template-collection')) return;
    /*
      The clamp is mobile only, so above the breakpoint there is nothing to
      open. Re-checked on resize rather than once, because a rotated phone
      crosses it.
    */
    if (window.matchMedia('(min-width: 1025px)').matches) return;

    /* A short retry window, because the variant's stylesheet may still be landing. */
    var tries = 0;
    (function attempt() {
      if (mounted) return;
      mount();
      if (!mounted && ++tries < 20) requestAnimationFrame(attempt);
    })();
  }

  function boot() {
    start();

    /*
      Re-checked on resize rather than once, because the clamp is mobile only
      and a rotated phone crosses the breakpoint.
    */
    window.addEventListener('resize', function () {
      if (!mounted) start();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
